import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ModalCloseButtonIcon } from "./SVGIcons";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./styles/modal-v2.css";

export const ITQModalV2 = ({
  isOpen,
  title,
  bodyContent,
  cancelButtonText,
  cancelButtonClicked,
  buttonsModal = false,
  isCenterd = false,
  size = "md",
}) => {
  return (
    <React.Fragment>
      <Modal
        className={`${"modal-" + size} itqan-modal-v2`}
        isOpen={isOpen}
        backdrop="static"
        centered={buttonsModal || isCenterd ? true : false}
        onClosed={() => {}}
      >
        <ModalBody>
          <div className="container">
            <div className="row">
              <div className="d-inline-flex align-items-center justify-content-between px-0">
                <p
                  className="inter inter-bold m-0"
                  style={{ fontSize: "1.5rem" }}
                >
                  {title}
                </p>
                <Icon
                  icon="material-symbols:close-rounded"
                  width="20"
                  height="20"
                  onClick={cancelButtonClicked}
                  role="button"
                />
              </div>
            </div>
            <div className="row">
              <div
                className="col-12 px-0"
                style={buttonsModal ? null : { marginBottom: "1rem" }}
              >
                {bodyContent}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
